import * as React from 'react';
import { createRoot } from 'react-dom/client';
import Box from '@mui/material/Box';
import { v4 as uuidv4 } from 'uuid';
//import { DateTime } from "luxon";


import {TabulatorFull as Tabulator} from "tabulator-tables"; //import Tabulator library
//import '../Bs4Theme/tabulator_scss/themes/tabulator_simple.scss';

import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportTabulator from './Bs4ReportTabulator';

import * as Bs4Columns from './Bs4Columns'

//window.luxon = DateTime;

export default class Bs4ReportTypeTabelka extends Bs4ReportTabulator {  

  getData() {
    return this.props.tablevals || [];
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const refTabulator = React.useRef();
    const report = this;

    React.useEffect(() => {
      this.selectable = "highlight";      
      if (this.tabulator) return;

      this.tabulator = new Tabulator(refTabulator.current, {
        reactiveData: true, //enable data reactivity
        height: this.props.bs4flexframe ? 'auto' : '100%', //height: '100%',
        columns: this.getColumns(this.props.tablecols), //define table columns
        data: this.getData(),
        rowFormatter: this.rowFormatter,
        locale:"pl-PL",
        //locale:true,
        langs: this.tabulatorLangs,
        movableColumns: true,        
        headerSortElement: this.headerSortElement,
        selectable: this.selectable,
        layout: "fitData",
      });

      this.tabulator.on("rowClick", (e, row) => {
        Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId);
      });                  
    }, [])    
    
    return (
      <Box ref={ref} height={'100%'} display='flex' flexDirection="column">
        <div ref={refTabulator}/>
        <report.ViewColumns/>
      </Box>
    )
  });
}